import I18n from 'i18n-js';
import React, { Component } from 'react';
import { func, shape } from 'prop-types';
import { connect } from 'react-redux';
import defaultUser from '../../../assets/images/defaultUser.svg';
import { getTotalDuration } from '../../common/utils/exchanges';
import { get } from '../../../container';
import { updateComment, updateAvatar } from '../actions/profile';

class Profile extends Component {
  static propTypes = {
    profile: shape().isRequired,
    updateComment: func.isRequired,
    updateAvatar: func.isRequired,
  };

  state = {
    editMod: false,
    commentContent: this.props.profile.me.comment || null,
  };

  constructor(props) {
    super(props);

    this.onChangeAvatar = this.onChangeAvatar.bind(this);
    this.onChangeEditMod = this.onChangeEditMod.bind(this);
    this.onChangeComment = this.onChangeComment.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  /**
   * {@inheritdoc}
   */
  componentDidUpdate(prevProps) {
    const { profile } = this.props;

    if (prevProps.profile.me === profile.me) {
      return;
    }

    this.setState({ commentContent: profile.me.comment });
  }

  /**
   * @param {String]} type
   */
  renderServices(type) {
    const list = this.props.profile.me[type].map(service => (
      <li key={service.uuid} className="tag">{service.name}</li>
    ));

    return (
      <div>
        <p className="services__title">{I18n.t(`pages.profile.services:${type}`)}</p>
        <ul className="tag-list">
          {list}
        </ul>
      </div>
    );
  }

  onChangeAvatar() {
    this.props.updateAvatar(this.avatar.files[0]);
  }

  onChangeEditMod() {
    const { editMod, commentContent } = this.state;

    if (editMod) {
      this.props.updateComment(commentContent);
    }

    this.setState({ editMod: !editMod });
  }

  onCancel(event) {
    event.preventDefault();

    const { profile } = this.props;

    this.setState({
      editMod: false,
      commentContent: profile.me.comment,
    });
  }

  /**
   * @param {Object} event
   */
  onChangeComment(event) {
    this.setState({ commentContent: event.target.value });
  }

  /**
   * {@inheritdoc}
   */
  render() {
    const { editMod, commentContent } = this.state;
    const { profile } = this.props;

    if (profile.loading) {
      return <div className="loader"></div>;
    }

    const {
      avatar,
      lastname,
      firstname,
      city,
      zipcode,
      balance,
      given,
      received,
    } = profile.me;

    return (
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-7">
            <div className="card profile">
              <div className="profile__info">
                <div className="user-picture">
                  <div className="user-picture__image" style={{ backgroundImage: `url(${avatar || defaultUser})` }}></div>
                  <input
                    type="file"
                    name="file"
                    id="file"
                    onChange={this.onChangeAvatar}
                    ref={ref => { this.avatar = ref; }}
                    className="user-picture__file"
                  />
                  <label
                    htmlFor="file"
                    className="user-picture__label"
                  >
                    Modifier
                  </label>
                </div>
                <p>
                  <span>{firstname} {lastname}</span>
                  <span>{city} ({zipcode})</span>
                </p>
                <div className="link link-avatar">
                  <input
                    type="file"
                    name="file"
                    id="file"
                    onChange={this.onChangeAvatar}
                    ref={ref => { this.avatar = ref; }}
                    className="link-avatar__file"
                  />
                  <label htmlFor="file">Modifier l'avatar</label>
                </div>
              </div>
              <div className="profile__description clear">
                {editMod ?
                  <textarea
                    placeholder={I18n.t('pages.profile.comment:placeholder')}
                    value={commentContent}
                    onChange={this.onChangeComment}
                  /> :
                  <p>{commentContent}</p>
                }
                <div>
                  {editMod && (
                    <a href=""
                       onClick={this.onCancel}
                       className="button button--small button--dark"
                    >
                      {I18n.t('pages.profile.comment:cancel')}
                    </a>
                  )}
                  <button
                    className="button button--small button--dark"
                    onClick={this.onChangeEditMod}
                  >
                    {I18n.t(`pages.profile.comment:${editMod ? 'validate' : 'edit'}`)}
                  </button>
                </div>
              </div>
            </div>
            <div className="card services">
              {this.renderServices('supplies')}
              {this.renderServices('demands')}
              <div className="services__footer">
                <a href={`mailto:${get('utpa_email')}`}>{I18n.t('pages.profile.services:edit')}</a>
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-sm-5">
            <div className="card time-balance">
              <p className="time-balance__available">
                <span>{balance}</span>
                {I18n.t('pages.profile.balance:total')}
              </p>
              <div>
                <p>{I18n.t('pages.profile.credit:given', { given: getTotalDuration(given) })}</p>
                <p>{I18n.t('pages.profile.credit:received', { received: getTotalDuration(received) })}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  profile: state.profile,
});

const mapDispatchToProps = dispatch => ({
  updateComment: comment => dispatch(updateComment(comment)),
  updateAvatar: avatar => dispatch(updateAvatar(avatar)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Profile);



// WEBPACK FOOTER //
// ./src/modules/profile/containers/Profile.js